import {
  makeDataState,
  makeListState,
  makePaginationState,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';

import { FOLLOW_USER } from '../storyDetail/types';

const initialState = {
  episode: makeDataState(),
  otherStories: {
    storyId: null,
    ...makePaginationState(),
  },
  recommendations: {
    storyId: null,
    headers: null,
    ...makePaginationState(),
  },
  paidChoices: makeListState(),
  episodeDonationRankings: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch episode
    case `${t.FETCH_EPISODE}_PENDING`:
      return {
        ...state,
        episode: {
          ...state.episode,
          isLoaded: false,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_EPISODE}_SUCCESS`:
      return {
        ...state,
        episode: {
          ...state.episode,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_EPISODE}_ERROR`:
      return {
        ...state,
        episode: {
          ...state.episode,
          status: STATUSES.ERROR,
        },
      };

    case t.SAVE_EPISODE_DATA:
      return {
        ...state,
        episode: {
          ...state.episode,
          data: {
            ...state.episode.data,
            content: {
              ...state.episode.data.content,
              data: action.data,
            },
          },
        },
      };

    // like comment
    case `${t.LIKE_COMMENT}_SUCCESS`:
      return {
        ...state,
        bestComments: {
          ...state.bestComments,
          list: state.bestComments.list.map((item) => {
            if (item.id === action.meta.commentId) {
              return {
                ...item,
                isLiked: !item.isLiked,
                likeCount: item.isLiked
                  ? item.likeCount - 1
                  : item.likeCount + 1,
              };
            }

            return item;
          }),
        },
      };

    // fetch author's other stories
    case `${t.FETCH_USER_OTHER_STORIES}_PENDING`:
      return {
        ...state,
        otherStories: {
          ...state.otherStories,
          status: STATUSES.PENDING,
          storyId: action.meta.storyId,
        },
      };

    case `${t.FETCH_USER_OTHER_STORIES}_SUCCESS`:
      return {
        ...state,
        otherStories: {
          ...state.otherStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: action.payload.result,
        },
      };

    case `${t.FETCH_USER_OTHER_STORIES}_ERROR`:
      return {
        ...state,
        otherStories: {
          ...state.otherStories,
          status: STATUSES.ERROR,
        },
      };

    // fetch story recommendations
    case `${t.FETCH_STORY_RECOMMENDATIONS}_PENDING`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          status: STATUSES.PENDING,
          storyId: action.meta.storyId,
        },
      };

    case `${t.FETCH_STORY_RECOMMENDATIONS}_SUCCESS`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.recommendations.pagination.items.concat(
              action.payload.result.items
            ),
          },
          headers: action.payload.headers,
        },
      };

    case `${t.FETCH_STORY_RECOMMENDATIONS}_ERROR`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          status: STATUSES.ERROR,
        },
      };

    // reset recommendations
    case t.RESET_RECOMMENDATIONS:
      return {
        ...state,
        // otherStories: {
        //   storyId: null,
        //   ...makePaginationState(),
        // },
        recommendations: {
          storyId: null,
          ...makePaginationState(),
        },
      };

    // follow user
    case `${FOLLOW_USER}_SUCCESS`: {
      if (!state.episode.isLoaded) {
        return state;
      }

      return {
        ...state,
        episode: {
          ...state.episode,
          data: {
            ...state.episode.data,
            story: {
              ...state.episode.data.story,
              user: {
                ...state.episode.data.story.user,
                isFollowing: !state.episode.data.story.user.isFollowing,
              },
            },
          },
        },
      };
    }

    case `${t.FETCH_PAID_CHOICES}_PENDING`:
      return {
        ...state,
        paidChoices: {
          ...state.paidChoices,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_PAID_CHOICES}_SUCCESS`:
      return {
        ...state,
        paidChoices: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result.map((c) => c.choiceId),
        },
      };

    case `${t.PURCHASE_CHOICE}_SUCCESS`:
      return {
        ...state,
        paidChoices: {
          ...state.paidChoices,
          list: state.paidChoices.list.concat([action.meta.choiceId]),
        },
      };

    case `${t.SAVE_WATCH_LATER}_SUCCESS`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          pagination: {
            ...state.recommendations.pagination,
            items: state.recommendations.pagination.items.map((item) => {
              if (item.id === action.meta.storyId) {
                return {
                  ...item,
                  isWatchLater: true,
                };
              }
              return item;
            }),
          },
        },
      };

    case `${t.DELETE_WATCH_LATER}_SUCCESS`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          pagination: {
            ...state.recommendations.pagination,
            items: state.recommendations.pagination.items.map((item) => {
              if (item.id === action.meta.storyId) {
                return {
                  ...item,
                  isWatchLater: false,
                };
              }
              return item;
            }),
          },
        },
      };

    case `${t.FETCH_EPISODE_DONATION_RANKINGS}_SUCCESS`:
      return {
        ...state,
        episodeDonationRankings: {
          ...state.episodeDonationRankings,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: action.payload.result.items,
          },
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/episodeDetail/reducer.js